import * as React from "react";
import { Navigate, useLocation, useParams } from "react-router";

/**
 * Weiterleitung `/vorgaenge/v2|v3|v5|v6/:id` → `/vorgaenge/:id`.
 *
 * Die Ansichten V2, V3, V5 und V6 gibt es seit dem 20.09.2026 nicht mehr (PO:
 * „die anderen Versionen vorher rausnehmen, das ist sonst confusend"). Ihre
 * Pfade bleiben trotzdem bestehen: sie stehen in Lesezeichen und in
 * verschickten Links, und ein Lesezeichen, das auf „Seite nicht gefunden"
 * führt, sieht aus wie ein verlorener Vorgang.
 *
 * Suchteil und Anker reisen mit: die Notizansicht liest heute keinen von
 * beiden, aber eine Weiterleitung, die sie verschluckt, fiele erst auf, wenn
 * es einmal einen gibt. `replace`, damit der Zurück-Knopf nicht wieder hier
 * landet.
 */
const VorgangAltpfadRedirect: React.FC = () => {
    const { id } = useParams();
    const { search, hash } = useLocation();
    return <Navigate to={`/vorgaenge/${id ?? ""}${search}${hash}`} replace />;
};

export default VorgangAltpfadRedirect;
